import { useState } from 'react';
import { Dialog, Box, Typography, Button } from '@mui/material';
import { PhoneFrame, TabletFrame } from './HtmlPreviewFrames';
import PreviewDeviceList from './creation/preview/PreviewDeviceList';
import { DEVICES, DeviceMode } from './creation/preview/previewDevices';

interface HtmlPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  htmlContent: string;
}

function HtmlPreviewDialog({ open, onClose, htmlContent }: HtmlPreviewDialogProps) {
  const [activeDevice, setActiveDevice] = useState<DeviceMode>('desktop');
  const [customWidth, setCustomWidth] = useState(1020);

  const previewWidth = DEVICES.find(device => device.key === activeDevice)?.width ?? customWidth;

  const iframe = (
    <iframe
      // Contenu de l'iframe : couleur en dur, le thème n'y est pas appliqué
      srcDoc={htmlContent || '<p style="color:#aaa;padding:16px;">Aucun contenu HTML</p>'}
      style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
      title="Aperçu email"
    />
  );

  const renderFrame = () => {
    if (activeDevice === 'mobile_responsive' || activeDevice === 'mobile_full') {
      return <PhoneFrame width={previewWidth}>{iframe}</PhoneFrame>;
    }
    if (activeDevice === 'tablet') return <TabletFrame width={previewWidth}>{iframe}</TabletFrame>;
    return (
      <Box sx={{ width: previewWidth, maxWidth: '100%', minHeight: 600, border: '1px solid', borderColor: 'divider', borderRadius: 1, overflow: 'hidden', backgroundColor: 'background.paper', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
        <Box sx={{ height: 600 }}>{iframe}</Box>
      </Box>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen PaperProps={{ sx: { borderRadius: 0, backgroundColor: 'grey.100' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 1.5, backgroundColor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="subtitle1" fontWeight={700} sx={{ letterSpacing: 0.5 }}>
          Aperçu
        </Typography>
        <Button variant="text" onClick={onClose} sx={{ textTransform: 'none', color: 'text.secondary', fontWeight: 500 }}>
          Fermer l&apos;aperçu ✕
        </Button>
      </Box>

      <Box sx={{ display: 'flex', height: 'calc(100vh - 56px)', overflow: 'hidden' }}>
        <PreviewDeviceList
          activeDevice={activeDevice}
          onDeviceChange={setActiveDevice}
          customWidth={customWidth}
          onCustomWidthChange={setCustomWidth}
        />

        <Box sx={{ flexGrow: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3, px: 2, gap: 2 }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{ backgroundColor: 'primary.main', textTransform: 'none', fontWeight: 500, '&:hover': { backgroundColor: 'primary.main', opacity: 0.9 } }}
          >
            Revenir à la page d&apos;origine
          </Button>
          {renderFrame()}
        </Box>
      </Box>
    </Dialog>
  );
}

export default HtmlPreviewDialog;
